import { createProject, deleteProject, editProject, getProjects } from "../../api/endpoints";
import { createMutation, createQuery } from "./apiHooks";

export const PROJECTS_QUERY_KEY = ["Projects"];

export const useGetProjects = createQuery(getProjects, {
  queryKey: PROJECTS_QUERY_KEY,
});

export const useEditProject = createMutation(
  editProject,
  {
    mutationKey: ["Projects", "Update"],
  },
  PROJECTS_QUERY_KEY,
);

export const useCreateProject = createMutation(
  createProject,
  {
    mutationKey: ["Projects", "Create"],
  },
  PROJECTS_QUERY_KEY,
);

export const useDeleteProject = createMutation(
  deleteProject,
  {
    mutationKey: ["Projects", "Delete"],
  },
  PROJECTS_QUERY_KEY,
);
